import AuthSubmitButton from "@/components/AuthSubmitButton";
import { FormInput } from "@/components/ui/FormInput";
import { useAuth0 } from "@auth0/auth0-react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { ssoSchema } from "./schema";
import { z } from "zod";
import { displayErrorToast } from "@/utils/toast";

const SSO_LOGIN_EMAILS = ["@abbvie.com"];

export const SSOLogin = () => {
  const { loginWithRedirect, isLoading: auth0Loading } = useAuth0();
  const [searchParams] = useSearchParams();

  const email = searchParams.get("email");

  const form = useForm<z.infer<typeof ssoSchema>>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      email: email || "",
    },
    resolver: zodResolver(ssoSchema),
  });

  const onSubmit = async (data: z.infer<typeof ssoSchema>) => {
    const isSSOLoginEmail = SSO_LOGIN_EMAILS.some((domain) =>
      data.email.endsWith(domain),
    );

    try {
      await loginWithRedirect({
        authorizationParams: {
          login_hint: !isSSOLoginEmail ? data.email : undefined,
          prompt: "login",
          connection: isSSOLoginEmail ? "Abbvie" : undefined,
        },
      });
    } catch (error) {
      displayErrorToast("Something went wrong");
    }
  };

  return (
    <div className="space-y-4">
      <form
        className="flex flex-col gap-3 py-3"
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <FormInput
          label="Work Email"
          placeholder="Enter your work email address"
          type="email"
          error={form.formState.errors.email?.message}
          disabled={auth0Loading}
          {...form.register("email")}
        />

        <div className="text-xs text-gray-500">
          Enter your work email address
        </div>

        <AuthSubmitButton
          loading={auth0Loading}
          text="Continue with SSO"
          disabled={!form.formState.isValid || auth0Loading}
        />
      </form>

      <div className="text-center text-sm text-gray-500">
        Having trouble? Contact your IT administrator or contact us at{" "}
        <a
          href="mailto:support@promptlayer.com"
          className="text-blue-600 hover:text-blue-800"
        >
          support@promptlayer.com
        </a>{" "}
        to set up.
      </div>
    </div>
  );
};
